// extracted by mini-css-extract-plugin
export default {"popUpButton":"PopUp_popUpButton__+gHDG","popUpHidden":"PopUp_popUpHidden__0fj5w"};